addEventListener('DOMContentLoaded', function() {
		init();
		const nextButton = document.querySelector('.testimonial-swiper-button-next')
		const prevButton = document.querySelector('.testimonial-swiper-button-prev')
    var testimonialSwiper = new Swiper(".testimonial-swiper", {
      spaceBetween: 100,
      watchSlidesProgress: true,
			slidesPerView: 1,
			loop: true,
			navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
			pagination: {
        el: ".testimonial-swiper-pagination",
        type: "progressbar",
      },
			autoplay: {
        delay: 4000,
        disableOnInteraction: true,
				pauseOnMouseEnter: true
      }

    });
});

function init () {
	const elements = document.querySelectorAll(".wp-block-dunesblocks-testimonial-carousel .swiper-wrapper > div")
	elements.forEach((elm)=> {
		elm.classList.add('swiper-slide')
	})
}
